import { fromJS } from 'immutable';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';

import { isAnyTypeOfGold } from 'pages/User/AccessLevel';

import { FirebaseMain } from '../firebase';
import firebaseNode from '../firebaseNode';
import {
  accessLevelFromShortName,
  genderFromShortName,
} from '../firebaseTranscribers.js';

import { actionCreators as mainChatActions } from './MainChatState';


const ADD_USER_TO_ROSTER = 'cam4/firebaseWatchers/roomRoster/ADD_USER_TO_ROSTER';
const REMOVE_USER_FROM_ROSTER = 'cam4/firebaseWatchers/roomRoster/REMOVE_USER_FROM_ROSTER';
const RESET_STATE = 'cam4/firebaseWatchers/roomRoster/RESET_STATE';
const UPDATE_USER_IN_ROSTER = 'cam4/firebaseWatchers/roomRoster/UPDATE_USER_IN_ROSTER';

export const NAME = 'roomRoster';

/*
INITIAL STATE
*/
const initialState = fromJS({ webUsers: {} });

/*
REDUCER
*/
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_USER_TO_ROSTER:
      return state.setIn(['webUsers', action.username], fromJS(action.userObj));

    case REMOVE_USER_FROM_ROSTER:
      return state.removeIn(['webUsers', action.username]);

    // TODO: investigate if this should merged with ADD_USER_TO_ROSTER
    case UPDATE_USER_IN_ROSTER:
      return state.setIn(['webUsers', action.username], fromJS(action.userObj));

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
}

/*
INPUT SELECTORS
*/

const webUsers = (state) => state[NAME].get('webUsers');

/*
ACTIONS
*/

function addUserToRoster(username, userObj) {
  return {
    type: ADD_USER_TO_ROSTER,
    username,
    userObj,
  };
}

function updateUserInRoster(username, userObj) {
  return {
    type: UPDATE_USER_IN_ROSTER,
    username,
    userObj,
  };
}

function removeUserFromRoster(username) {
  return {
    type: REMOVE_USER_FROM_ROSTER,
    username,
  };
}

function stateToInitialValues() {
  return { type: RESET_STATE };
}

// revert state to initial values
function resetRoomRoster() {
  return (dispatch) => {
    dispatch(stateToInitialValues());
  };
}

function parseLightRosterUser(key, userStr) {
  const firstDelimiter = userStr.indexOf('$');
  const secondDelimiter = userStr.indexOf('$', firstDelimiter + 1);
  const thirdDelimiter = userStr.indexOf('$', secondDelimiter + 1);

  return {
    isOnline: true,
    stealthLevel: parseInt(userStr.charAt(4), 10),
    accessLevel: accessLevelFromShortName(userStr.charAt(1)),
    gender: genderFromShortName(userStr.charAt(0)),
    isBroadcasting: userStr.substring(thirdDelimiter + 1, thirdDelimiter + 2),
    isSilenced: userStr.charAt(3) === '1',
    originalUsername: key,
    userID: parseInt(userStr.substring(firstDelimiter + 1, secondDelimiter), 10),
    isRoomModerator: userStr.charAt(2),
    isFanclubSubscribed: userStr.charAt(5),
    notifyBroacaster: userStr.charAt(6),
    viewerType: parseInt(userStr.charAt(7), 10),
  };
}

/*
WATCHERS
*/
function watchRoomRoster(roomName, viewerUsername) {
  // eslint-disable-next-line
  const rosterRef = FirebaseMain.child(`${firebaseNode.CHAT_ROOMS}/${roomName}/roster`);
  const rosterLightRef = FirebaseMain.child(`r/${roomName}`);

  return (dispatch) => {
    rosterLightRef.on('child_changed', (snapshot) => {
      const username = snapshot.key();
      const parsedRosterUser = parseLightRosterUser(username, snapshot.val());
      dispatch(updateUserInRoster(username, parsedRosterUser));
    });
    rosterLightRef.on('child_added', (snapshot) => {
      const username = snapshot.key();
      const parsedRosterUser = parseLightRosterUser(username, snapshot.val());
      const chatActions = bindActionCreators(mainChatActions, dispatch);
      const { accessLevel, originalUsername } = parsedRosterUser;
      const isGold = isAnyTypeOfGold(accessLevel);
      dispatch(addUserToRoster(username, parsedRosterUser));
      if (isGold && viewerUsername === originalUsername && parsedRosterUser.notifyBroacaster === '1') {
        chatActions.addMessage({
          type: 5,
          senderOriginalUsername: originalUsername,
          messageKey: Date.now(),
        });
      }
    });
    rosterLightRef.on('child_removed', (snapshot) => {
      const username = snapshot.key();
      dispatch(removeUserFromRoster(username));
    });
  };
}

/*
EXPORTS
*/
export const selector = createStructuredSelector({ roomRoster: createStructuredSelector({ webUsers }) });

export const actionCreators = {
  watchRoomRoster,
  resetRoomRoster,
};
